/**
 *
 * Asynchronously loads the component for ServerError
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ServerError = lazyLoad(
  () => import('./index'),
  module => module.ServerError
);
